import React from 'react';
import type { HelpCenterSettingsEmailAppWithLayout as HelpCenterSettingsEmailType } from '@atlassian/jira-spa-apps-help-center-settings-email/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyHelpCenterSettingsEmail = lazyForPaint<typeof HelpCenterSettingsEmailType>(
	() =>
		import(
			/* webpackChunkName: "async-help-center-settings-email", jiraSpaEntry: "async-help-center-settings-email" */ '@atlassian/jira-spa-apps-help-center-settings-email'
		),
);

export const HelpCenterSettingsEmail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyHelpCenterSettingsEmail}
		pageId="help-center-settings-email"
		shouldShowSpinner
	/>
);
